"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SurveyRefDataFactory = void 0;
var utils_1 = require("../../utils");
exports.SurveyRefDataFactory = {
    createInstance: function (params) {
        var defaultParams = {
            itemsByCategoryUuid: {},
            taxonUuidIndex: {},
            taxonIndex: {}
        };
        var _a = __assign(__assign({}, defaultParams), params), itemsByCategoryUuid = _a.itemsByCategoryUuid, taxonUuidIndex = _a.taxonUuidIndex, taxonIndex = _a.taxonIndex;
        var categoryItemUuidIndex = {};
        var categoryItemIndex = {};
        Object.entries(itemsByCategoryUuid).forEach(function (_a) {
            var categoryUuid = _a[0], items = _a[1];
            items.forEach(function (item) {
                var _a;
                utils_1.Objects.setInPath({
                    obj: categoryItemUuidIndex,
                    path: [categoryUuid, item.parentUuid || 'null', ((_a = item.props) === null || _a === void 0 ? void 0 : _a.code) || ''],
                    value: item.uuid
                });
                categoryItemIndex[item.uuid] = item;
            }, {});
        });
        return { categoryItemUuidIndex: categoryItemUuidIndex, categoryItemIndex: categoryItemIndex, taxonUuidIndex: taxonUuidIndex, taxonIndex: taxonIndex };
    }
};
//# sourceMappingURL=factory.js.map